var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.571A8.571 8.571 0 018.571 0H31.43A8.571 8.571 0 0140 8.571V31.43A8.571 8.571 0 0131.429 40H8.57A8.571 8.571 0 010 31.429V8.57zm7.783 7.7l12.303 17.57h5.468L13.25 16.272H7.783zm-.005 17.57l5.47-7.81 2.735 3.907-2.733 3.904H7.778zM26.804 6.668L17.35 20.17l2.736 3.907 12.19-17.41h-5.47zm.991 27.174v-18.82l4.482-6.401V33.84h-4.482z",
    fill: "var(--joy-palette-text-primary)"
  })));
}
export default SvgXai;